import React from 'react';
import TailwindScope from './TailwindScope';
import Banner, { HomeGlyph } from './Tailwind/Banner';

import AwardPayoutRequestIcon from '../../assets/img/award-payout-requests.svg';
import { formatPhoneNumber, isStudentOrAlumni } from '../../util/miscUtil';

interface Senior {
  first_name?: string;
  last_name?: string;
  alumni_updated_first_name?: string;
  alumni_updated_last_name?: string;
}

interface SpecialistUser {
  id?: number;
  first_name?: string;
  last_name?: string;
}

export interface AftercareSpecialist {
  user?: SpecialistUser;
  office_phone?: string;
  cell_phone?: string;
}

interface BannerProps {
  senior: Senior;
  alumni?: boolean;
  roles?: string[];
  aftercareSpecialist?: AftercareSpecialist;
  handleGotoHomepage?: () => void;
  title?: string;
}

const AwardPaymentBanner = ({ senior, roles = [], aftercareSpecialist, handleGotoHomepage, title }: BannerProps) => {
  const isUserStudentOrAlumni = isStudentOrAlumni(roles);
  const seniorFirstName = senior.alumni_updated_first_name || senior.first_name || '';
  const seniorLastName = senior.alumni_updated_last_name || senior.last_name || '';
  const hasSpecialist = Boolean(aftercareSpecialist?.user?.id && aftercareSpecialist.user.id > 0);
  const specialistName = hasSpecialist
    ? `${aftercareSpecialist?.user?.first_name || ''} ${aftercareSpecialist?.user?.last_name || ''}`.trim()
    : 'N/A';
  const officePhone = hasSpecialist ? formatPhoneNumber(aftercareSpecialist?.office_phone) || 'N/A' : 'N/A';
  const cellPhone = hasSpecialist ? formatPhoneNumber(aftercareSpecialist?.cell_phone) || 'N/A' : 'N/A';
  const defaultTitle = isUserStudentOrAlumni ? 'Award Payment Requests' : `Award Payment Requests for ${seniorFirstName} ${seniorLastName}`;
  const bannerTitle = title || defaultTitle;

  return (
    <TailwindScope>
      <Banner
        leftFeatureIcon={<img src={AwardPayoutRequestIcon} alt='Award Payment Requests Icon' className='w-5/5 md:w-4/5' />}
        title={bannerTitle}
        subtitleOne={
          <>
            <label className='text-base font-semibold leading-5 text-white'>Successful Futures Specialist:</label>{' '}
            <span className='mr-5 text-base leading-5 text-white'>{specialistName}</span>
          </>
        }
        subtitleTwo={
          <>
            <aside className='text-left'>
              <label className='text-base font-semibold leading-5 text-white'>Office Phone</label>{' '}
              <span className='mr-5 text-base leading-5 text-white'>{officePhone}</span>
            </aside>
            <aside className='text-left'>
              <label className='text-base font-semibold leading-5 text-white'>Cell Phone</label>{' '}
              <span className='mr-5 text-base leading-5 text-white'>{cellPhone}</span>
            </aside>
          </>
        }
        rightActionIcon={<HomeGlyph className='h-[1.813rem] w-[1.813rem] cursor-pointer text-white' />}
        onRightActionClick={handleGotoHomepage}
        rightActionAriaLabel='return home'
        classNames={{ rightActionButton: 'appearance-none border-solid shadow-none' }}
      />
    </TailwindScope>
  );
};

export default AwardPaymentBanner;
